import { Icon, IconProps } from "@chakra-ui/react";

function SendIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.4384 11.0541C18.611 10.7049 18.611 10.2952 18.4384 9.94606C18.2863 9.63861 18.0196 9.4774 17.8814 9.39963C17.7326 9.3159 17.5419 9.23013 17.3518 9.14461L3.36527 2.85072C3.17075 2.76315 2.97682 2.67584 2.81322 2.61917C2.66303 2.56714 2.36064 2.47209 2.02584 2.56525C1.64749 2.67052 1.34061 2.94748 1.19722 3.31309C1.07033 3.63662 1.13398 3.94714 1.17039 4.10187C1.21004 4.27041 1.27708 4.47228 1.34433 4.67476L2.69806 8.75336C2.80706 9.08176 2.86156 9.24595 2.9629 9.36736C3.0524 9.47457 3.1674 9.55757 3.29734 9.60874C3.44449 9.66668 3.6175 9.66668 3.96351 9.66668H9.99993C10.4602 9.66668 10.8333 10.0398 10.8333 10.5C10.8333 10.9602 10.4602 11.3333 9.99993 11.3333H3.97927C3.63413 11.3333 3.46156 11.3333 3.31467 11.391C3.18496 11.442 3.0701 11.5247 2.9806 11.6315C2.87925 11.7525 2.82447 11.9161 2.7149 12.2434L1.35027 16.3197C1.2823 16.5226 1.2146 16.7248 1.17443 16.8935C1.13761 17.0482 1.07289 17.3593 1.19943 17.6836C1.34233 18.0499 1.64924 18.3276 2.02794 18.4333C2.3633 18.5269 2.66638 18.4315 2.81662 18.3795C2.98054 18.3227 3.17495 18.2352 3.37011 18.1473L17.3517 11.8556C17.5419 11.77 17.7326 11.6843 17.8814 11.6005C18.0196 11.5228 18.2864 11.3615 18.4384 11.0541Z"
				fill="currentColor"
			/>
		</Icon>
	);
}

export default SendIcon;
